<template>
    <b-row cols="2" class="m-0 mb-3 text-white">

        <b-col class="p-0">
            <b-row cols="2" class="leftCrad m-1 shadow h-100">
                <b-col cols="3" class="d-flex align-items-end p-0 leftCornel">
                    <div class="text-center w-100 ">
                        <div class="" style="color: #fead5c">{{ data.outingValue }}</div>
                        <div class="small">{{ data.outingHEValue }}</div>
                        <div class="nameFive">{{ data.outingFiveValue }}</div>
                        <div v-if="staffonly">{{ data.outingCompareMan }}</div>
                    </div>
                </b-col>
                <b-col cols="9">
                    <b-row  v-for="(item , index) in MainName" v-bind:key="index" align-v="center"
                           class="text-center  namerow" fluid>
                        <b-col class="p-0">
                            <div class="nameTitle">{{ item.name }}</div>
                        </b-col>
                        <b-col class="p-0" style="font-size: 0.6rem;">{{ item.stroke }}</b-col>
                        <b-col class="p-0" v-if="staffonly"><div v-if="index >0" style="color: #fead5c">/ {{parseInt(item.stroke)+parseInt(MainName[index-1].stroke)}}</div></b-col>

                        <b-col class="p-0">
                            <div class="nameHEValue">{{ item.HEvalue }}</div>
                            <div class="nameFive">{{ item.FiveValue }}</div>
                        </b-col>
                        <b-col class="p-0" v-if="staffonly">{{ item.Compare }}</b-col>
                    </b-row>
                </b-col>
                <b-col cols="3">
                </b-col>
                <b-col cols="9">

                    <b-row align-v="center" class="text-center  namerow rightCornel" fluid>
                        <b-col class="p-0"></b-col>
                        <b-col class="p-0" style="color: #fead5c">{{ data.totalValue }}</b-col>
                        <b-col class="p-0">
                            <div class="nameHEValue"> {{ data.totalHEValue }}</div>
                            <div class="nameFive"> {{ data.totalFiveValue }}</div>
                        </b-col>
                        <b-col class="p-0" v-if="staffonly">{{ data.totalCompareMan }}</b-col>
                    </b-row>
                </b-col>
            </b-row>

        </b-col>

        <b-col class="p-0" >
            <b-row cols="2" class="rightCrad m-1 shadow h-100">
                <div class=" mx-auto d-flex align-self-center">
                    <div class="text-center mx-auto">
                        <h2>{{ data.year }} 年</h2>
                        <h2>{{ data.month }} 月</h2>
                        <h2>{{ data.day }} 日</h2>
                    </div>

                </div>

            </b-row>



        </b-col>
    </b-row>
</template>
<style>
    .leftCrad {
        background: linear-gradient(126deg, rgba(84, 85, 101, 1) 0%, rgba(68, 72, 84, 1) 100%);
        border-radius: 1.5rem !important;
    }

    .leftCornel {
        background-color: #00000020;
        border-top-left-radius: 1.5rem 1.5rem;
        border-top-right-radius: 0em 0em;
        border-bottom-right-radius: 0em 0em;
        border-bottom-left-radius: 0em 0em;
    }

    .rightCornel {
        background-color: #00000020;
        border-top-left-radius: 0rem 0rem;
        border-top-right-radius: 0em 0em;
        border-bottom-right-radius: 1.5rem 1.5rem;
        border-bottom-left-radius: 0em 0em;
    }

    .rightCrad {
        background: linear-gradient(126deg, rgba(183, 137, 98, 1) 0%, rgba(208, 168, 118, 1) 100%);
        border-radius: 1.5rem !important;
    }

    .namerow {
        height: 60px;
    }

    .nameTitle {
        font-size: 1.4rem;
    }

    .nameHEValue {
        font-size: 0.5rem;
    }

    .nameFive {
        font-size: 0.6rem;
    }
</style>
<script>
import { mapState } from 'vuex'

export default {
  name: 'NameCardOne',
  props: {
    data: Object,
  },
  computed: {
    ...mapState(['profiledata']),
    MainName: function () {
      return this.NameCounting(this.data);
    },
    staffonly: function () {
      if (Object.keys(this.profiledata).length !== 0) {
        if (this.profiledata.staff == 0) {
          return false;
        } else {
          return true;
        }
      }else{
        return false;
      }

    },
    salesOnly: function () {
      if (Object.keys(this.profiledata).length !== 0) {
        if (this.profiledata.sales == 0) {
          return false;
        } else {
          return true;
        }
      }else{
        return false;
      }

    },

  },
  data () {
    return {}
  },
  methods: {
    NameCounting (data) {
      let nameData = []
      if (data.type == 0) {
        if (data.oname.length == 2) {
          nameData[0] = {name: '', stroke: data.NameStrokes_one, HEvalue: '', FiveValue: '', Compare: ''}
          nameData[1] = {
            name: data.oname[0],
            stroke: data.NameStrokes_two,
            HEvalue: data.skyHEValue,
            FiveValue: data.skyFiveValue,
            Compare: data.skyCompareMan
          }
          nameData[2] = {
            name: data.oname[1],
            stroke: data.NameStrokes_three,
            HEvalue: data.manHEValue,
            FiveValue: data.manFiveValue,
            Compare: ''
          }
          nameData[3] = {
            name: '',
            stroke: data.NameStrokes_four,
            HEvalue: data.landHEValue,
            FiveValue: data.landFiveValue,
            Compare: data.landCompareMan
          }
        }
        if (data.oname.length == 3) {
          nameData[0] = {name: '', stroke: data.NameStrokes_one, HEvalue: '', FiveValue: '', Compare: ''}
          nameData[1] = {
            name: data.oname[0],
            stroke: data.NameStrokes_two,
            HEvalue: data.skyHEValue,
            FiveValue: data.skyFiveValue,
            Compare: data.skyCompareMan
          }
          nameData[2] = {
            name: data.oname[1],
            stroke: data.NameStrokes_three,
            HEvalue: data.manHEValue,
            FiveValue: data.manFiveValue,
            Compare: ''
          }
          nameData[3] = {
            name: data.oname[2],
            stroke: data.NameStrokes_four,
            HEvalue: data.landHEValue,
            FiveValue: data.landFiveValue,
            Compare: data.landCompareMan
          }
        }

      } else {
        if (data.oname.length == 4) {
          nameData[0] = {name: data.oname[0], stroke: data.NameStrokes_one, HEvalue: '', FiveValue: '', Compare: ''}
          nameData[1] = {
            name: data.oname[1],
            stroke: data.NameStrokes_two,
            HEvalue: data.skyHEValue,
            FiveValue: data.skyFiveValue,
            Compare: data.skyCompareMan
          }
          nameData[2] = {
            name: data.oname[2],
            stroke: data.NameStrokes_three,
            HEvalue: data.manHEValue,
            FiveValue: data.manFiveValue,
            Compare: ''
          }
          nameData[3] = {
            name: data.oname[3],
            stroke: data.NameStrokes_four,
            HEvalue: data.landHEValue,
            FiveValue: data.landFiveValue,
            Compare: data.landCompareMan
          }
        }
        if (data.oname.length == 3) {
          nameData[0] = {name: data.oname[0], stroke: data.NameStrokes_one, HEvalue: '', FiveValue: '', Compare: ''}
          nameData[1] = {
            name: data.oname[1],
            stroke: data.NameStrokes_two,
            HEvalue: data.skyHEValue,
            FiveValue: data.skyFiveValue,
            Compare: data.skyCompareMan
          }
          nameData[2] = {
            name: data.oname[2],
            stroke: data.NameStrokes_three,
            HEvalue: data.manHEValue,
            FiveValue: data.manFiveValue,
            Compare: ''
          }
          nameData[3] = {
            name: '',
            stroke: data.NameStrokes_four,
            HEvalue: data.landHEValue,
            FiveValue: data.landFiveValue,
            Compare: data.landCompareMan
          }
        }
      }

      return nameData
    }

  }
}
</script>
